/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-11-12T09:55:24.313
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listReportPlaceorder,
	listReportPlaceorderInit,
	listReportPlaceorderByAuthorizations,
	deleteReportPlaceorder
	
} from '@api/report/ReportPlaceorder';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listReportPlaceorder({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportPlaceorder(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportPlaceorderByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportPlaceorderByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportPlaceorderInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportPlaceorderInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteReportPlaceorder({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportPlaceorder({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
